<template>
  <div>
    <page-title></page-title>
    <transition name="fade" mode="out-in">
      <div v-if="cardType==='list'" class="card bg-dark" key="list">
        <div class="card-body">
          <div class="table-header">
            <form >
              <div class="form-row">
                <div class="col-md-3 col-12 my-1">
              <label class="sr-only">名称或电话</label>
              <input type="text" v-model="search.q" class="form-control form-control mr-md-2 mr-sm-0"
                     placeholder="名称或电话">
                </div>
                <div class="col-md-2 col-12 my-1">

                <button type="button" @keyup.enter="loadCustomers(true)" @click="loadCustomers(true)" class="btn btn btn-primary btn-block">搜索</button>
                </div>
                  <div class="col-md-2 col-12 my-1 ml-auto">

                  <button type="button" @click="clickEdit('add')" class="btn btn btn-success btn-block ">
                <i class="iconfont icon-c_add"></i> 添加客户
              </button>
                  </div>
                  </div>
            </form>
          </div>
          <div class="table-responsive">
            <loading v-if="loading.customers"></loading>
            <table v-else class="table table-leemma ">
              <thead>
              <tr>
                <th>姓名</th>
                <th>设备数</th>
                <th>邮箱</th>
                <th>地址</th>
                <th>联系方式</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in customers">
                <td>{{item.name}}</td>
                <td>{{item.device_count}}</td>
                <td>{{item.email}}</td>
                <td>{{district[item.province]}}-{{district[item.city]}}-{{district[item.district]}}{{item.address}}</td>
                <td>{{item.phone_number}}</td>
                <td>{{item.status}}</td>
                <td>
                  <button @click="clickEdit('edit',index)" class="btn btn-primary btn-sm">修改信息</button>
                  <button @click="deleteCustomer(index)" class="btn  btn-outline-danger btn-sm">删除客户</button>
                </td>
              </tr>
              </tbody>
            </table>
            <page :page-size="search.pageSize" :count="search.count" :page-no="search.pageNo" @click="paging"></page>

          </div>
        </div>
      </div>
      <div v-else-if="cardType==='edit'||cardType==='add'" class="card bg-dark" key="edit">
        <div class="card-body">
          <form>
            <div class="form-group">
              <label>绑定设备</label>
              <button @click="openDeviceModal" type="button" class="btn btn-primary btn-sm">添加设备</button>
              <div>
                <div v-for="(device,index) in customerInfo.devices" class="device-item">{{device.name}}<i
                  @click="deleteBindDevice(index)" class="iconfont icon-shanchu3"></i></div>

              </div>
            </div>
            <div class="form-group">
              <label>登陆名称</label>
              <input type="text" v-model="customerInfo.name" class="form-control" placeholder="请输入名称">
              <small id="emailHelp" class="form-text text-muted">登陆名称</small>

            </div>
            <div class="form-group">
              <label>角色</label>
              <select v-model="customerInfo.role" class="form-control">
                <option v-for="role in roles" :value="role.val">{{role.label}}</option>
              </select>
            </div>
            <div class="form-group">
              <label>邮箱</label>
              <input type="text" v-model="customerInfo.email" class="form-control" placeholder="请输入邮箱">
            </div>

            <div class="form-group">
              <label>地址</label>
              <v-distpicker :placeholders="distPlaceholder" v-on:selected="selectedArea"></v-distpicker>
            </div>
            <div class="form-group">
              <label>详细地址</label>
              <input type="text" v-model="customerInfo.address" class="form-control" placeholder="请输入详细地址">
            </div>
            <div class="form-group">
              <label>电话</label>
              <input type="text" v-model="customerInfo.phone_number" class="form-control" placeholder="请输入电话">
            </div>
            <div class="form-group">
              <label>密码设置</label>
              <a data-toggle="collapse" data-target="#collapseExample" aria-expanded="false"
                 aria-controls="collapseExample">
                <i class="iconfont icon-moreunfold" style="color:#03A9F5;cursor:pointer "></i>
              </a>
              <div :class="{show:cardType==='add'}" class="collapse" id="collapseExample">
                <div class="form-group">
                  <label>密码</label>
                  <input type="password" v-model="customerInfo.password" class="form-control" placeholder="请输入密码">
                </div>
                <div class="form-group">
                  <label>重复密码</label>
                  <input type="password" v-model="customerInfo.password_confirmation" class="form-control"
                         placeholder="请输入密码">
                </div>
              </div>
            </div>


            <button v-if="cardType==='add'" @click="addCustomer" type="button" class="btn btn-primary">确定</button>
            <button v-if="cardType==='edit'" @click="saveCustomer" type="button" class="btn btn-primary">确定</button>
            <button type="button" @click="cardType='list'" class="btn btn-link">取消</button>
          </form>
        </div>
      </div>
    </transition>
    <div ref="modal" class="modal fade" id="customer-modal" tabindex="-1" role="dialog" aria-labelledby="customer-modal"
         aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content bg-dark">
          <div class="modal-header">
            <h5 class="modal-title">{{modal.title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="form-inline ">
              <div class="form-group" style="margin: 10px 0">
                <label class="sr-only">设备号或设备名称</label>
                <input type="text" class="form-control" v-model="devicesSearch.q" placeholder="设备号或设备名称">
              </div>
              <button type="button" @click="loadDevices" class="btn btn-primary mx-3 ">搜索</button>
            </form>
            <table class="table">
              <thead>
              <tr>
                <th>设备号</th>
                <th>设备名称</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(device,index) in devices">
                <td>{{device.device_sn}}</td>
                <td>{{device.name}}</td>
                <td>
                  <button v-if="!device.isBind" type="button" @click="addBindDevice(index)"
                          class="btn btn-sm btn-primary">添加
                  </button>
                  <button v-else type="button" class="btn btn-sm btn-outline-primary">已添加</button>

                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  import pageTitle from '@/components/pageTitle'
  import VDistpicker from 'v-distpicker'
  import district from '@/assets/lib/district'
  import page from '@/components/pagination'


  export default {
    name: 'customers',
    components: {
      pageTitle,
      VDistpicker,
      page
    },
    data() {
      return {
        cardType: 'list',
        customers: [],
        customerInfo: {
          devices: []
        },
        devices: [],
        devicesSearch: {
          pageSize: 5,
          pageNo: 1,
          count: '',
          q: ''
        },
        search: {
          pageSize: 15,
          pageNo: 1,
          count: '',
          q: ''
        },
        roles: [
          {label: '管理员', val: 'manager'},
          {label: '工程师', val: 'engineer'},
          {label: '业务员', val: 'employee'},
        ],
        district,
        distPlaceholder: {
          province: '---',
          city: '---',
          district: '---'
        },
        modal: {
          title: '设备列表'
        },
        loading:{
          customers:false
        }
      }
    },
    created() {

      this.loadCustomers()
    },
    mounted() {
      if (this.$route.query.type === 'list') {
        this.cardType = 'list'
      }
    },
    methods: {
      paging(no) {
        this.search.pageNo = no;
        this.loadCustomers()
      },
      loadCustomers(isSearch) {
        this.loading.customers=true;

        if(isSearch){
          this.search.pageNo=1
        }
        let url = 'customers',
          params = {
            auth_token: 'default',
            q: this.search.q,
            page_size: this.search.pageSize,
            page_no: this.search.pageNo
          };

        this.$http.get(url, {params}).then(data => {
          this.loading.customers=false;

          if (data.status_code === 'SUCCEEDED') {
            this.cardType = 'list';
            this.customers = data.payload;
            this.search.count = data.total;
          }
        })
      },
      // loadCustomer() {
      //   let url = 'customers',
      //     params = {
      //       auth_token: 'default',
      //       q: this.search.q,
      //       page_size: this.search.pageSize,
      //       page_no: this.search.pageNo
      //     };
      //   this.$http.get(url, {params}).then(data => {
      //     // this.loading.customers=false;
      //     if (data.status_code === 'SUCCEEDED') {
      //       this.cardType = 'list';
      //       this.customers = data.payload;
      //       this.search.count = data.total;
      //     }
      //   })
      // },
      selectedArea(area) {
        this.customerInfo.province = area.province.code;
        this.customerInfo.city = area.city.code;
        this.customerInfo.district = area.area.code;
      },
      clickEdit(type, index) {
        if (type === 'add') {
          this.customerInfo = {
            devices: []
          }

        } else if (type === 'edit') {
          let c = this.customers[index];
          this.customerInfo = JSON.parse(JSON.stringify(c));
          this.distPlaceholder = {
            province: district[c.province], city: district[c.city], district: district[c.district]
          }
        }
        this.cardType = type;
      },

      addCustomer() {
        let url = 'customers/create',
          params = JSON.parse(JSON.stringify(this.customerInfo));
        params.devices = JSON.stringify(params.devices);
        params.auth_token = 'default';
        this.$http.post(url, params).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.$message.success('操作成功')
            this.loadCustomers()
          } else {
            this.$message.error('操作失败：' + data.msg)
          }
        })
      },
      saveCustomer() {
        let customer = this.customerInfo,
          url = `customers/${customer.id}/edit`,
          params = JSON.parse(JSON.stringify(customer));
        params.devices = JSON.stringify(params.devices);
        params.auth_token = 'default'
        this.$http.patch(url, params)
          .then(data => {
            if (data.status_code === 'SUCCEEDED') {
              this.$message.success('操作成功')
              this.loadCustomers()
            } else {
              this.$message.error('操作失败：' + data.msg)
            }
          })

      },
      deleteCustomer(index) {
        this.$confirm('确定删除客户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let c = this.customers[index],
            url = `customers/${c.id}/destroy`,
            params = {
              auth_token: 'default'
            };
          this.$http.delete(url, {params}).then(data => {
            if (data.status_code === 'SUCCEEDED') {
              this.$message.success('操作成功')
              this.loadCustomers()
            } else {
              this.$message.error('操作失败：' + data.msg)
            }
          })
        })
      },
      openDeviceModal() {
        $(this.$refs.modal).modal('show');
        this.loadDevices();
      },
      loadDevices() {
        let url = 'devices',
          s = this.devicesSearch,
          params = {
            auth_token: 'default',
            q: s.q,
            page_no: s.pageNo,
            page_size: s.pageSize
          };
        this.$http.get(url, {params}).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.devices = data.payload;
            s.count = data.total;
          } else {

          }
        })


      },
      addBindDevice(index) {
        let bindDevices = this.customerInfo.devices,
          device = this.devices[index];
        bindDevices.push({
          id: device.id,
          name: device.name,
        });
        this.filterBindDevice()
      },
      deleteBindDevice(index) {
        let devices = this.customerInfo.devices;
        console.log(devices)
        devices.splice(index, 1);
      },
      filterBindDevice() {
        let list = this.devices,
          bind = this.customerInfo.devices;
        for (let i = 0; i < list.length; i++) {

          for (let n = 0; n < bind.length; n++) {
            if (list[i].id === bind[n].id) {
              list[i].isBind = true
            }
          }
        }
      }
    }

  }
</script>

<style type="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: all .3s
  }

  .fade-enter {
    opacity: 0;
    transform: translateX(-10px);
  }

  .fade-leave-to {
    opacity: 0;
    transform: translateX(10px);
  }

  .device-item {

    margin: 10px;
    border: 1px solid;
    padding: 5px;
    display: inline-block;
    border-radius: 5px;
    color: #03A9F5;
  }

  .device-item .iconfont {
    padding: 0 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/customers.vue